import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import {
    NbCheckboxModule,
    NbInputModule,
    NbCardModule,
    NbDialogModule,
    NbWindowModule,
    NbButtonModule,
    NbSelectModule,
    NbRadioModule,
    NbUserModule,
    NbDatepickerModule,
    NbTagModule
  } from '@nebular/theme';

import { Toggle } from './components/toggle.component';
import { AgmCoreModule } from '@agm/core';

import { CustomActionViewComponent } from  './smart-table-custom-button-view/custom-action-view.component';
import { CheckboxButtonViewComponent } from './smart-table-custom-button-view/checkbox-button-view.component';
import { StatusButtonViewComponent } from './smart-table-custom-button-view/status-button-view.component';
import { ActivityLogsButtonViewComponent } from './smart-table-custom-button-view/activity-logs-button-view.component';
import { PinCodeComponent } from './components/pin-code.component';
import { CKEditorModule } from 'ng2-ckeditor';
import { Loading } from './components/loading.component';
import { DialogOKComponent } from './modals/dialog-ok.component';
import { DialogChangePasswordComponent} from './modals/dialog-change-password';
import { DialogChangePINComponent } from './modals/dialog-change-pin';
import { FileDownloadComponent } from './file-download/file-download.component';
import { DialogConfirmComponent } from './modals/dialog-confirm.component';
import { DialogYesNoComponent } from './modals/dialog-yesno.component';
import { PreviewNavigationLeft } from './components/preview-navigation/preview-navigation-left';
import { PreviewNavigationRight } from './components/preview-navigation/preview-navigation-right';
import { DisplayLoginUser } from './components/display-login-user/display-login-user';
import { DialogCreateFolderComponent } from './modals/dialog-create-folder.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FileUploadComponent } from './controls/file-upload/file-upload.component';   
import { FileUploadService } from './controls/file-upload/file-upload.service';
import { EditMetadataComponent } from './controls/edit-metadata/edit-metadata.component';
import { EditMetadataService } from './controls/edit-metadata/edit-metadata.services';
import { DialogAssignFolderComponent } from './modals/dialog-assign-folder.component';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { DialogShowMapComponent } from './modals/dialog-show-map.component';
import { DialogShareFolderComponent } from './modals/dialog-share-folder.component';
import { CheckboxListViewComponent } from '../shared/controls/checkbox-list/checkbox-list.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NbCheckboxModule,
        NbInputModule,
        CKEditorModule,
        NbCardModule,
        NbDialogModule.forChild(),
        NbWindowModule.forChild(),
        NbButtonModule,
        NbSelectModule,
        NbRadioModule,
        NbUserModule,
        PdfViewerModule,
        ReactiveFormsModule,
        Ng2SmartTableModule,
        AgmCoreModule.forRoot(),
        NbDatepickerModule,
        NbTagModule
    ],    
    declarations: [
        CustomActionViewComponent,
        CheckboxButtonViewComponent,
        StatusButtonViewComponent,
        ActivityLogsButtonViewComponent,
        Toggle,
        PinCodeComponent,
        Loading,
        DialogOKComponent,
        DialogChangePasswordComponent,
        DialogChangePINComponent,
        FileDownloadComponent,
        DialogConfirmComponent,
        DialogYesNoComponent,
        PreviewNavigationLeft,
        PreviewNavigationRight,
        DisplayLoginUser,
        DialogCreateFolderComponent,
        FileUploadComponent,
        EditMetadataComponent,
        DialogAssignFolderComponent,
        DialogShowMapComponent,
        DialogShareFolderComponent,
        CheckboxListViewComponent
    ],
    exports: [
        CustomActionViewComponent,
        CheckboxButtonViewComponent,
        StatusButtonViewComponent,
        ActivityLogsButtonViewComponent,
        Toggle,
        PinCodeComponent,
        Loading,
        DialogOKComponent,
        DialogChangePasswordComponent,
        DialogChangePINComponent,
        FileDownloadComponent,
        DialogConfirmComponent,
        DialogYesNoComponent,
        PreviewNavigationLeft,
        PreviewNavigationRight,
        DisplayLoginUser,
        DialogCreateFolderComponent,
        FileUploadComponent,
        EditMetadataComponent,
        DialogAssignFolderComponent,
        DialogShowMapComponent,
        DialogShareFolderComponent,
        CheckboxListViewComponent
        
    ],
    providers: [
        FileUploadService,
        EditMetadataService
    ],
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [],
        };
    }
}